import React, {useEffect, useState, useMemo, useRef} from "react"
import {Card, CardBody, CardHeader, CardFooter} from "../../../../_metronic/_partials/controls";
import {ProductsList} from "./ProductCards/ProductsList";
import {fetchCategories, saveOrders, submitOrders, fetchTenantPaymentSettings, previewPaymentSummary} from "./ordersCrud";
import { getPaymentSummary, mergePaymentPreview, getPaymentPreviewRequestBody } from "./utils/paymentSummary";
import { PaymentTaxBreakdown } from "./components/PaymentTaxBreakdown";
import {isBuyerPriceEditLocked} from "./utils/buyerPriceEdit";
import { getInventoryQty, getInventoryColumnLabel, isExternalBuyer } from "./utils/inventoryDisplay";
import {useHistory} from "react-router-dom";
import {useSelector} from "react-redux";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import SVG from "react-inlinesvg";
import {toAbsoluteUrl} from "../../../../_metronic/_helpers";
import {Select,
    ListSubheader,
    TextField,
    InputAdornment,
    IconButton,
    Collapse,
    Switch} from "@material-ui/core";
import FilledInput from "@material-ui/core/FilledInput";
import MenuItem from "@material-ui/core/MenuItem";
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import SearchIcon from "@material-ui/icons/Search";
import Grid from '@material-ui/core/Grid';
import Input from '@material-ui/core/Input';
import { invalid } from "moment/moment";
import axios from 'axios';
import { formatPrMunicipalityForPdf } from "../../../utils/prMunicipality";
import NumberInput from "../../../components/NumberInput";

export function SupplierInfo({supplier, setIsSupplerSelected, companies, setNewOrder}){

    const inititalCategoryTree = {
        branches: 0,
        selectedCategories:[],
        categoryType:"",
        children:[]
    }

    const initialCategory = {
        supplierId: "",
        categories: [],
        type: ""
    }

    const [categoriesTree,setCategoriesTree] = useState(inititalCategoryTree)

    const [objectsArray,setObjectsArray] = useState([]);
    const [defaultCategory,setDefaultCategory] = useState("")

    const [open, setOpen] = React.useState(false);
    const [notApprovedOpen, setNotApprovedOpen] = useState(false);
    const [isCompanySelected, setIsCompanySelected] = useState(false);

    const [selectedOption, setSelectedOption] = useState();
    const [searchText, setSearchText] = useState("");
    const [isSubmitExpanded, setIsSubmitExpanded] = useState(false);

    const [currentOrders,setCurrentOrders] = useState([]);
    const [currOrderIndex, setCurrOrderIndex] = useState(null);
    const [defaultInvoiceDate, setDefaultInvoiceDate] = useState("");
    const [defaultShipDate, setDefaultShipDate] = useState("");
    const [invoice,setInvoice] = useState(null);

    const pickupRouteFallback = [{ name: 'Pick Up' }];

    const setPickupInvoiceAfterSubmit = (response, ordersToSubmit) => {
        if (response?.data?.shipVia === 'HOME') {
            setInvoice(response.data);
            return;
        }
        const pickupOrder = (ordersToSubmit || []).find((o) => o.shipVia === 'HOME');
        if (!pickupOrder) return;
        setInvoice({
            ...pickupOrder,
            routes: pickupOrder.routes?.length ? pickupOrder.routes : pickupRouteFallback,
        });
    };

    const [openCW, setOpenCW] = useState(false);
    const [catchWeight, setCatchWeight] = useState("")
    const [catchWeightProduct, setCatchWeightProduct] = useState(null)
    const [catchWeightOrder, setCatchWeightOrder] = useState(null)

    const [alertTitle, setAlertTitle] = useState("");
    const [alertOpen, setAlertOpen] = useState(false);
    const [alertText, setAlertText] = useState("");
    const [onlinePaymentEnabled, setOnlinePaymentEnabled] = useState(false);
    const paymentRefetchTimersRef = useRef({});
    const currentOrdersRef = useRef([]);
    currentOrdersRef.current = currentOrders;

    const history = useHistory();

    const handleAlertClose = () => {
        setAlertOpen(false);
        setAlertTitle("");
        setAlertText("");
        setInvoice(null);
    }

    const fireAlert = (title, text) => {
        setAlertTitle(title);
        setAlertText(text);
        setAlertOpen(true);
    }

    const containsText = (text, searchText) => {
        // console.log(companies)
        if(text){
            return text.toLowerCase().indexOf(searchText.toLowerCase()) > -1;
        }
        
    }

    const displayedOptions = useMemo(() => {
        return companies.filter((company) => containsText(company.businessName, searchText) || containsText(company.sageCustomerId, searchText))
    },[searchText]);

    

    function handleClickOpen() {
        setOpen(true);
    }

    function handleClose() {
        setOpen(false);
    }

    function handleCloseCW() {
        setOpenCW(false);
    }

    function handleNotApprovedClickOpen() {
        setNotApprovedOpen(true);
    }

    function handleNotApprovedClose() {
        setNotApprovedOpen(false);
    }


    const {user,accessToken} = useSelector(
        ({auth}) => ({
            user: auth.user != null ? auth.user : null,
            accessToken: auth.authToken,
        }))
        // { companies, companyIdList } = useSelector(state => state.companyReducer);

    useEffect(() => {
        if (!accessToken) return
        fetchTenantPaymentSettings(accessToken)
            .then((res) => setOnlinePaymentEnabled(!!res.data?.onlinePaymentEnabled))
            .catch(() => setOnlinePaymentEnabled(false))
    }, [accessToken])

    const scheduleOrderPaymentRefetch = (orderId) => {
        if (!onlinePaymentEnabled || !orderId || !accessToken) return
        const key = String(orderId)
        if (paymentRefetchTimersRef.current[key]) {
            clearTimeout(paymentRefetchTimersRef.current[key])
        }
        paymentRefetchTimersRef.current[key] = setTimeout(() => {
            const order = currentOrdersRef.current.find((o) => String(o._id) === key)
            const body = getPaymentPreviewRequestBody(order)
            if (!body) return

            previewPaymentSummary(accessToken, body)
                .then((response) => {
                    const summary = response.data?.paymentSummary
                    if (!summary) return
                    setCurrentOrders((prev) =>
                        prev.map((o) =>
                            String(o._id) === key
                                ? mergePaymentPreview(o, summary)
                                : o
                            )
                    )
                })
                .catch(() => {})
        }, 300)
    }

    const initialCompanyValues = {
        _id: "",
        corporationName: "",
        businessName: "",
        deliveryAddress: "",
        deliveryCity: "",
        deliveryZipcode: "",
        businessPhoneNumber: "",
        businessFax: "",
        businessEmail: "",
        businessType: "",
        taxIdNumber: "",
        businessEstablishmentDate: "",
        placeOfBusinessDescription: ""
    }

    const [company,setCompany] = useState(initialCompanyValues)
    // const [companies,setCompanies] = useState([])
    const [locations,setLocations] = useState([])
    const [fullCategoryTree,setFullCategoryTree] = useState([])
    const [isDataFetched, setIsDataFetched] = useState(false)

    

    useEffect(() =>{

        fetchCategories(supplier._id,accessToken).then(response =>{
            console.log("categories fetched: ", response.data)
            setObjectsArray(response.data)
            setFullCategoryTree(response.data)
            setCategoriesTree({
                branches: 0,
                selectedCategories: [],
                categoryType: response.data.type,
                children:response.data
            })
            setDefaultCategory(response.data.type)
            setIsDataFetched(true)
        });

        if (companies.length == 1){
            setCompany(companies[0])
            setLocations(companies[0].locations)
            setIsCompanySelected(true)
        }

        // fetchCompanies(user.id,accessToken,supplier._id).then(response =>{
        //     console.log("Jahhahah response",response.data)
        //     
        //     setCompanies(response.data)
        //     // setCompany(response.data[0])
        //     // setLocations(response.data[0].locations)
        // })
    },[])

    const handleCompanyChange = (element) => {

        const clickedCompany = companies.find(company => company._id == element.target.value)
        const clickedCompanyLocations = clickedCompany.locations

        console.log("Companies from Supplier Info: ", companies)
        console.log("Clicked Company: ", clickedCompany)

        if(clickedCompanyLocations.length > 0){
            setCompany(clickedCompany)
            setLocations(clickedCompanyLocations)
            setIsCompanySelected(true)
        } else{
            handleNotApprovedClickOpen()
        }
        
    }

    const handleBack = () => {
        setNewOrder(false)
    }

    // Helper function to get the appropriate price field based on user role
    const getProductPrice = (product) => {
        if(user.roles.includes("buyer_external")) {
            return product.fob || 0;
        }
        return (product.listPrice || product.listPrice == '') ? product.listPrice : product.price;
    }

    // Helper function to set the appropriate price field based on user role
    const setProductPrice = (product, newPrice) => {
        if(user.roles.includes("buyer_external")) {
            return {
                ...product,
                fob: newPrice
            };
        }
        if(product.listPrice || product.listPrice == ''){
            return {
                ...product,
                listPrice: newPrice
            };
        }
        return {
            ...product,
            price: newPrice
        };
    }

    // Helper function to check if an order can be edited (includes special cases)
    const canEditOrder = (order) => {
        // Standard case: Not Submitted orders can always be edited
        if (order.status === "Not Submitted") {
            return true;
        }
        
        // Special case 1: Received orders with future invoice dates
        if (order.status === "Received" && order.invoiceDate) {
            const today = new Date();
            const invoiceDate = new Date(order.invoiceDate);
            if (invoiceDate.setHours(0, 0, 0, 0) >= today.setHours(0, 0, 0, 0)) {
                return true;
            }
        }
        
        // Special case 2: WAHMEY tenant with specific route statuses
        if (user.tenant === process.env.REACT_APP_WAHMEY_TENANT) {
            if (order.routeStatus && 
                order.routeStatus !== 'Completed' && 
                order.routeStatus !== 'Routing' && 
                order.routeStatus !== 'Sent to WMS') {
                return true;
            }
        }
        
        return false;
    };

    const handleProductAmountChange = (orderId, productId, productAmount) => {
        let orderIndex = currentOrders.findIndex(order => order._id === orderId)
        let order = currentOrders[orderIndex]
        let newOrders = [...currentOrders]

        let products = order.products
        let productIndex = products.findIndex(product => product._id === productId)

        const oldTotalAmount = order.totalProductQty
        const oldTotalCost = order.totalCost
        let newTotalAmount = oldTotalAmount
        let newTotalCost = parseFloat(oldTotalCost)

        const product = {...products[productIndex]}
        let productPrice = getProductPrice(product)
        const selectedUnitObject = product.selectedUnit ? product.selectedUnit : product.defaultUnitOfMeasurement
        const conversionFactor = selectedUnitObject ? selectedUnitObject.conversionFactor : 1

        const oldProductAmount = product.amount;
        let newAmountParsed = parseFloat(productAmount)

        if(isNaN(newAmountParsed)){
            newAmountParsed = 0
        }

        if(productPrice > 0){
            if(product.isCatchWeight){
                if(product.isStaticCatchWeight && product.catchWeights){
                    newTotalCost -= parseFloat(productPrice) * product.staticCatchWeight * oldProductAmount
                    newTotalCost += parseFloat(productPrice) * product.staticCatchWeight * newAmountParsed 
                }
            } else{
                newTotalCost -= parseFloat(productPrice) * oldProductAmount * conversionFactor
                newTotalCost += parseFloat(productPrice) * newAmountParsed * conversionFactor
            }
        }

        newTotalAmount -= oldProductAmount
        newTotalAmount += newAmountParsed

        if(product.isStaticCatchWeight && product.catchWeights){
            let catchWeights = []
            for(let i = 0;i < parseInt(newAmountParsed); i++){
                catchWeights.push(product.staticCatchWeight)
            }
            product.catchWeights = catchWeights
        } else if (product.isCatchWeight && product.catchWeights && newAmountParsed == 0){
            
            newTotalCost -= parseFloat(productPrice) * (product.catchWeights.length > 0 ? product?.catchWeights?.reduce((total, currWeight) => total + parseFloat(currWeight)) : 0)
            product.catchWeights = []
        }

        products[productIndex] = {
            ...product,
            amount : newAmountParsed,
        }

        if(newTotalAmount == 0){
            newTotalCost = 0
        }

        const newOrder = {
            ...order,
            totalProductQty : newTotalAmount,
            totalCost : Math.round( parseFloat(newTotalCost) * 1e2 ) / 1e2,
            products : products
        }

        newOrders[orderIndex] = newOrder
        
        setCurrentOrders(newOrders)
        scheduleOrderPaymentRefetch(orderId)
    }

    const handleProductUnitChange = (orderId, productId, selectedUnitId) => {

        let orderIndex = currentOrders.findIndex(order => order._id === orderId)
        let order = currentOrders[orderIndex]
        let newOrders = [...currentOrders]

        let products = order.products
        let productIndex = products.findIndex(product => product._id === productId)

        const product = {...products[productIndex]}
        if(!product.isCatchWeight){
            const oldTotalCost = order.totalCost
            let newTotalCost = parseFloat(oldTotalCost)

            let productPrice = getProductPrice(product)
            const productAmount = product.amount;
            const oldSelectedUnitObject = product.selectedUnit ? product.selectedUnit : product.defaultUnitOfMeasurement
            const newSelectedUnitObject = product.unitsOfMeasurement.find(uom => uom.uomId == selectedUnitId)
            console.log("Selected Unit: ", oldSelectedUnitObject)
            console.log("Selected Unit: ", newSelectedUnitObject)

            const oldConversionFactor = oldSelectedUnitObject.conversionFactor
            const newConversionFactor = newSelectedUnitObject.conversionFactor

            if(productPrice > 0){
                newTotalCost -= parseFloat(productPrice) * productAmount * oldConversionFactor
                newTotalCost += parseFloat(productPrice) * productAmount * newConversionFactor
            }

            products[productIndex] = {
                ...product,
                selectedUnit : newSelectedUnitObject,
            }

            const newOrder = {
                ...order,
                totalCost : Math.round( parseFloat(newTotalCost) * 1e2 ) / 1e2,
                products : products
            }

            newOrders[orderIndex] = newOrder
            
            setCurrentOrders(newOrders)
            scheduleOrderPaymentRefetch(orderId)
        }
    }

    const handlePriceChange = (orderId, productId, newPrice) => {
        let orderIndex = currentOrders.findIndex(order => order._id === orderId)
        let order = currentOrders[orderIndex]
        let newOrders = [...currentOrders]

        let products = order.products
        let productIndex = products.findIndex(product => product._id === productId)
        const product = products[productIndex]

        let newPriceParsed = parseFloat(newPrice)
        const selectedUnitObject = product.selectedUnit ? product.selectedUnit : product.defaultUnitOfMeasurement
        const conversionFactor = selectedUnitObject ? selectedUnitObject.conversionFactor : 1

        const oldPrice = getProductPrice(product)
        const oldTotalCost = order.totalCost
        
        let newTotalCost = parseFloat(oldTotalCost)
        let totalWeight = 0

        if(product.isCatchWeight && product.catchWeights){
            totalWeight = product.catchWeights.length > 0 ? product?.catchWeights?.reduce((total, currWeight) => total + parseFloat(currWeight)) : 0
        }
        
        if(oldPrice == '' || oldPrice == 0){
            newTotalCost -= parseFloat(product.amount * 0)
        } else{
            if(product.isCatchWeight && product.catchWeights){
                newTotalCost -= parseFloat(totalWeight * oldPrice)
            } else{
                newTotalCost -= parseFloat(product.amount * conversionFactor * oldPrice)
            }
        }   

        if(!isNaN(newPriceParsed)){
            
            if(product.isCatchWeight  && product.catchWeights){
                newTotalCost += parseFloat(totalWeight * newPriceParsed)
            } else{
                newTotalCost += parseFloat(product.amount * conversionFactor * newPriceParsed)
            }
        }  

        if(isNaN(newPriceParsed)){
            newPriceParsed = ""
        }

        products[productIndex] = setProductPrice(product, newPriceParsed)

        const newOrder = {
            ...order,
            totalCost : Math.round( parseFloat(newTotalCost) * 1e2 ) / 1e2,
            products : products
        }

        newOrders[orderIndex] = newOrder
        
        setCurrentOrders(newOrders)
        scheduleOrderPaymentRefetch(orderId)
    }

    function handleRemove(orderId, productId) {
        let orderIndex = currentOrders.findIndex(order => order._id === orderId)
        let order = currentOrders[orderIndex]
        let newOrders = [...currentOrders]

        const productToRemove = order.products.find(product => product._id == productId)
        const productAmount = productToRemove.amount
        let productPrice = getProductPrice(productToRemove)

        if(productPrice == '' || productPrice == 0){
            productPrice = 0
        }

        // if(productToRemove.isCatchWeight){
        //     productPrice = productPrice * productToRemove.avgWeight
        //     productPrice = Math.round( parseFloat(productPrice) * 1e2 ) / 1e2
        // }

        const selectedUnitObject = productToRemove.selectedUnit ? productToRemove.selectedUnit : productToRemove.defaultUnitOfMeasurement
        const conversionFactor = selectedUnitObject ? selectedUnitObject.conversionFactor : 1

        let newTotalCost = parseFloat(order.totalCost)
        newTotalCost -= productAmount * conversionFactor * productPrice

        let newTotalAmount = order.totalProductQty
        newTotalAmount -= productAmount

        let products = order.products.filter(product => product._id !== productId)

        const newOrder = {
            ...order,
            totalProductQty : newTotalAmount,
            totalCost : Math.round( parseFloat(newTotalCost) * 1e2 ) / 1e2,
            products : products
        }
        
        if(products.length > 0){
            newOrders[orderIndex] = newOrder
        } else{
            newOrders = currentOrders.filter(currOrder => currOrder._id !== orderId)
        }
        
        setCurrentOrders([...newOrders])
        if (products.length > 0) {
            scheduleOrderPaymentRefetch(orderId)
        }
    }

    const handleOrderCommentChange = (orderIndex, newComment) => {
        let newOrders = [...currentOrders]
        newOrders[orderIndex].comment = newComment
        
        setCurrentOrders(newOrders)
    }

    const handleOrderCustomerPoChange = (orderIndex, newCustomerPo) => {
        let newOrders = [...currentOrders]
        newOrders[orderIndex].customerPo = newCustomerPo
        
        setCurrentOrders(newOrders)
    }

    const handleOrderShipViaChange = (orderIndex, newShipVia, orderId) => {
        let newOrders = [...currentOrders]
        newOrders[orderIndex].shipVia = newShipVia
        
        if(newShipVia == "HOME"){
            const currOrderIndex = newOrders.findIndex(order => order._id === orderId)
            let currOrder = {...newOrders[currOrderIndex]}
            let newTotalCost = currOrder.totalCost
            
            let resultProducts = currOrder.products.map(item => {

                let currProduct = {...item}
                
                if(currProduct.isStaticCatchWeight && !Array.isArray(currProduct?.catchWeights)){
                    let currProductPrice = getProductPrice(currProduct)
                    let catchWeights = []

                    for(let i = 0; i < currProduct.amount; i++){
                        catchWeights.push(currProduct.staticCatchWeight)
                    }
    
                    const totalWeight = (catchWeights.reduce((total, currWeight) => total + parseFloat(currWeight)))
                    currProduct.catchWeights = catchWeights
                    newTotalCost += totalWeight * currProductPrice
                } 

                return currProduct
            })

            newOrders[currOrderIndex].totalCost = parseFloat(newTotalCost.toFixed(2))
            newOrders[currOrderIndex].products = resultProducts

        }

        setCurrentOrders(newOrders)
        scheduleOrderPaymentRefetch(orderId)
    }

    // Helper function to get available ship via options for an order
    const getAvailableShipViaOptions = (order) => {
        const options = [company?.shipVia, ...supplier.shipViaOptions.filter(option => option !== company?.shipVia)]
        return options.filter(option => option) // Remove any undefined/null values
    }

    // Helper function to auto-select ship via when only one option is available
    const autoSelectShipVia = (orderIndex) => {
        const order = currentOrders[orderIndex]
        const availableOptions = getAvailableShipViaOptions(order)
        
        if (availableOptions.length === 1 && !order.shipVia) {
            handleOrderShipViaChange(orderIndex, availableOptions[0], order._id)
        }
    }

    const handleOrderShipToChange = (orderIndex, newShipTo) => {
        let newOrders = [...currentOrders]
        newOrders[orderIndex].allecInvWareHouse = newShipTo

        setCurrentOrders(newOrders)
    }

    const handleDefaultInvoiceDateChange = (e) => {
        
        let newOrders = [...currentOrders]

        if(user.tenant == process.env.REACT_APP_WAHMEY_TENANT){
            for(let i = 0; i < newOrders.length; i++){
                newOrders[i].invoiceDate = e.target.value
                newOrders[i].shipDate = e.target.value
            }
            setDefaultInvoiceDate(e.target.value)
            setDefaultShipDate(e.target.value)

        } else{
            for(let i = 0; i < newOrders.length; i++){
                newOrders[i].invoiceDate = e.target.value
            }
            setDefaultInvoiceDate(e.target.value)
        }
        
        setCurrentOrders(newOrders)
    }

    const handleDefaultShipDateChange = (e) => {
        
        let newOrders = [...currentOrders]

        for(let i = 0; i < newOrders.length; i++){
            newOrders[i].shipDate = e.target.value
        }

        setDefaultShipDate(e.target.value)
        setCurrentOrders(newOrders)
    }

    const handleOrderInvoiceDateChange = (orderIndex, newInvoiceDate) => {
        let newOrders = [...currentOrders]
        newOrders[orderIndex].invoiceDate = newInvoiceDate

        if(user.tenant == process.env.REACT_APP_WAHMEY_TENANT){
            newOrders[orderIndex].shipDate = newInvoiceDate
        }
        
        setCurrentOrders(newOrders)
    }

    const handleOrderShipDateChange = (orderIndex, newShipDate) => {
        let newOrders = [...currentOrders]
        newOrders[orderIndex].shipDate = newShipDate

        if(user.tenant == process.env.REACT_APP_WAHMEY_TENANT){
            newOrders[orderIndex].invoiceDate = newShipDate
        }
        
        setCurrentOrders(newOrders)
    }

    const handleOrderExpectedDeliveryDateChange = (orderIndex, newExpectedDeliveryDate) => {
        let newOrders = [...currentOrders]
        newOrders[orderIndex].expectedDeliveryDate = newExpectedDeliveryDate

        setCurrentOrders(newOrders)
    }

    const handleSubmitSingleOrder = async (orderIndex, isAdminOverride = false) => {

        // Check if user is buyer_creator - they cannot submit orders
        if(user.roles && user.roles.includes("buyer_creator")){
            fireAlert("Cannot Submit Order", "buyer_creator role cannot submit orders. Please contact an approver.");
            return;
        }

        if (onlinePaymentEnabled && supplier?.payment?.enabled) {
            fireAlert(
                "Complete your order in the cart",
                "Online payment is enabled for your account. You will be taken to your cart to use Pay & Submit or Pay on Delivery."
            );
            setTimeout(() => history.push("/orders/confirmation"), 400);
            return;
        }

        let order = {...currentOrders[orderIndex]}
        let isOrdersValid = true
        let isCatchWeightValid = true
        let ordersToSubmit = []

        let orderProducts = []

        let invalidMessage = ""
        let outOfStockItem = []
        let invalidCatchWeightItems = []

        let orderStatus = "Submitted"
        if(user.roles.includes("buyer_store") || user.roles.includes("buyer_external") || user.roles.includes("buyer_store_admin")){
            orderStatus = "Pending Approval"
        }

        order.products.map(product => {
            
            if(product._id !== process.env.REACT_APP_FUEL_ID){
                const stockQty = getInventoryQty(product, user);
                if(stockQty !== null && product.amount > stockQty){
                    isOrdersValid = false
                    outOfStockItem.push(product.name)
                    // invalidMessage += "Not enough items to fulfill order, except for fuel, amount to order must be less than QoH. "
                    // setCurrOrder(order)
                    setCurrOrderIndex(orderIndex)
                }
            }
            const productPrice = getProductPrice(product)
            if(productPrice === '' || productPrice < 0){
                isOrdersValid = false
                invalidMessage += "All unit price must be 0 or greater. "
                // setCurrOrder(null)
                setCurrOrderIndex(null)
            }

            if(order.shipVia == "HOME" && product.isCatchWeight){
                if(product.catchWeights && product.catchWeights.length < product.amount){
                    
                    isCatchWeightValid = false
                    invalidCatchWeightItems.push(product.name)
                } else if(!product.catchWeights){
                    
                    isCatchWeightValid = false
                    invalidCatchWeightItems.push(product.name)
                }
            }

            if(product.amount > 0){
                orderProducts.push(product)
            }
        })
        if (process.env.REACT_APP_MCS_TENANT !== user.tenant) {
            if (order.invoiceDate && order.shipDate && order.invoiceDate !== '' && order.shipDate !== '') {

            } else {
                isOrdersValid = false
                invalidMessage += "To submit, order must have an invoice date and a ship date. "
                // setCurrOrder(null)
                setCurrOrderIndex(null)
            }
        }else{
            if (order.invoiceDate && order.shipDate && order.invoiceDate !== '' && order.shipDate !== '') {

            } else {
                isOrdersValid = false;
                if (!order.invoiceDate || order.invoiceDate === '' || !order.shipDate || order.shipDate === '') {
                    isOrdersValid = false;
                    invalidMessage += "To submit, order must have an invoice date and a ship date. ";
                }
                if (!order.allecInvWareHouse || order.allecInvWareHouse === '') {
                    isOrdersValid = false;
                    invalidMessage += "To submit, order must select a valid ship to warehouse. ";
                }
                setCurrOrderIndex(null);
            }
        }

        if(outOfStockItem.length > 0){
            invalidMessage += "Not enough inventory for the following items to fulfill order: " + outOfStockItem.join(", ") + ". "
        }

        if(!isCatchWeightValid){
            isOrdersValid = false

            invalidMessage += "All catch weight items must register weights! Items missing weights: " + invalidCatchWeightItems.join(", ") + ". "
            setCurrOrderIndex(null)
        }

        if(orderProducts.length > 0){
            ordersToSubmit.push({
                ...order,
                status: orderStatus,
                products : orderProducts,
                user: user
            })
        } 

        // setIsOrdersValid(isOrdersValid)

        if(isOrdersValid){

            // console.log("Order to submit: ", ordersToSubmit[0])
            await submitOrders(user.id, ordersToSubmit, accessToken).then(response =>{
                
                let newCurrentOrders = [...currentOrders]
                newCurrentOrders.splice(orderIndex, 1)
                setCurrentOrders(newCurrentOrders)

                setCurrOrderIndex(null)

                setPickupInvoiceAfterSubmit(response, ordersToSubmit)

                fireAlert("Success!", `Order #${order.orderNumber} has been submitted!`)

                setCompany(initialCompanyValues)
                setLocations([])
                setIsCompanySelected(false)

                window.scrollTo({
                    top: 0,
                    behavior: "smooth" // Optional, smooth scrolling effect
                });
            }).catch(e=>{console.log(e)})
        } else{
            if(isAdminOverride){
                
                await submitOrders(user.id, ordersToSubmit, accessToken).then(response =>{

                    let newCurrentOrders = [...currentOrders]
                    newCurrentOrders.splice(orderIndex, 1)
                    setCurrentOrders(newCurrentOrders)

                    setCurrOrderIndex(null)

                    setPickupInvoiceAfterSubmit(response, ordersToSubmit)

                    fireAlert("Success!", "Admin override! Some order was invalid but was submitted anyways. " + invalidMessage)

                    setCompany(initialCompanyValues)
                    setLocations([])
                    setIsCompanySelected(false)
                    
                    

                    window.scrollTo({
                        top: 0,
                        behavior: "smooth" // Optional, smooth scrolling effect
                      });
                }).catch(e=>{console.log(e)})
            } else{
            
                fireAlert("Warning!", invalidMessage)
                // handleClickOpen()
            }
        }
    }

    const handleSaveOrders = () => {
        let ordersToSubmit = []

        currentOrders.map((order, index) => {
            let orderProducts = []

            order.products.map(product => {
                if(product.amount > 0){
                    orderProducts.push(product)
                }
            })
            /*Añadir los nuevos aquí!*/
            ordersToSubmit.push({
                orderId : order._id,
                products : orderProducts,
                comment: order.comment,
                shipDate: order.shipDate,
                invoiceDate: order.invoiceDate,
                expectedDeliveryDate: order.expectedDeliveryDate,
                customerPo : order.customerPo,
                shipVia : order.shipVia,
                proofOfDelivery : order.proofOfDelivery,
                deliveryPurpose : order.deliveryPurpose,
                allecInvWareHouse : order.allecInvWareHouse,
                contactPerson : order.contactPerson,
                phoneNumber : order.phoneNumber,
            })
        })
        
        console.log(ordersToSubmit)

        saveOrders(ordersToSubmit, accessToken).then(response =>{
            window.location.reload()
        }).catch(e=>{console.log(e)})
    }

    const handleDeliveryPurposeChange = (index, value) => {
        let newOrders = [...currentOrders];
        newOrders[index].deliveryPurpose = value;
        setCurrentOrders(newOrders);
    };

    const handleContactPerson = (index, value) => {
        let newOrders = [...currentOrders];
        newOrders[index].contactPerson = value;
        setCurrentOrders(newOrders);
    };

    const handlePhoneNumber = (index, value) => {
        let newOrders = [...currentOrders];
        newOrders[index].phoneNumber = value;
        setCurrentOrders(newOrders);
    };

    const handleProofOfDeliveryChange = (index, checked) => {
        let newOrders = [...currentOrders];
        newOrders[index].proofOfDelivery = checked;
        setCurrentOrders(newOrders);
    };
    const handlePrintInvoice = async () => {

        const salesTaxCode = invoice.company[0].salesTaxCode
        let municipalTaxSum = 0
        let stateTaxSum = 0

        invoice.products.forEach(currProduct => {
            if(currProduct.isTaxable){
                const productPrice = getProductPrice(currProduct)
                if(salesTaxCode == "SALES PR"){
                    stateTaxSum += (productPrice * currProduct.amount) * 0.105
                    municipalTaxSum += (productPrice * currProduct.amount) * 0.01
                } else if(salesTaxCode == "10.5C"){
                    stateTaxSum += (productPrice * currProduct.amount) * 0.105
                }
            }
        })

        let totalAmount = 0
        const salesOrderProductsData = invoice.products.map(currItem => {
            let itemPrice = getProductPrice(currItem)
            let itemTotalAmount = 0

            if(invoice.shipVia == "HOME" && currItem.isCatchWeight){
                const totalWeight = currItem.catchWeights?.length > 0 ? currItem?.catchWeights?.reduce((total, currWeight) => total + parseFloat(currWeight)) : 0
                itemTotalAmount = (itemPrice * totalWeight)
                totalAmount += itemPrice * totalWeight;
            } else{
                itemTotalAmount = (itemPrice * currItem.amount)
                totalAmount += itemPrice * currItem.amount
            }
            
            return {
                name: currItem.name,
                category: currItem.category,
                sku: currItem.sku,
                unitPrice: itemPrice,
                units: currItem.amount,
                itemPrice: itemPrice,
                totalAmount: itemTotalAmount.toFixed(2),
                isCatchWeight: currItem.isCatchWeight,
                catchWeights: currItem.catchWeights ? currItem.catchWeights : [],
            }
        })
        const salesOrderData = {
            storeName: invoice.companyName,
            submissionDate: invoice.submissionDate,
            requestedDeliveryDate: invoice.shipDate,
            routeName: invoice.routes?.[0]?.name ?? 'Pick Up',
            orderNumber: invoice.orderNumber,
            salesRep: invoice.user[0].fullName,
            products: salesOrderProductsData,
            clientNumber: invoice.company[0].sageCustomerId,
            paymentTerm: invoice.company[0].dueDays,
            supplierName: invoice.supplier[0].entityName,
            supplierDescription: invoice.supplier[0].description,
            supplierPhone1: invoice.supplier[0].phoneNumber,
            supplierPhone2: invoice.supplier[0].phoneNumber2,
            supplierFax: invoice.supplier[0].fax,
            supplierAddress: `${invoice.supplier[0].physicalAddress}, ${formatPrMunicipalityForPdf(invoice.supplier[0].physicalCity)}, Puerto Rico, ${invoice.supplier[0].physicalZipcode}`,
            supplierDisclaimer: invoice.supplier[0].disclaimer,
            totalAmount: totalAmount.toFixed(2),
            sageInvoiceNumber: invoice.sageInvoiceNumber ? invoice.sageInvoiceNumber : false,
            salesTaxAmount: invoice.salesTaxAmount ? invoice.salesTaxAmount : false,
            totalCostTax: (totalAmount + stateTaxSum + municipalTaxSum).toFixed(2),
            comment: invoice.comment,
            stateTax: stateTaxSum,
            municipalTax: municipalTaxSum
        }

        
        
        const supplierTenantId = invoice.supplier[0].tenantId
        const urlPath = process.env.REACT_APP_WMS_API_HTTPS + (process.env.REACT_APP_ENV === 'DEV' ?
            `${process.env.REACT_APP_WMS_API_URL}/tenants/${supplierTenantId}/route_records/store_order_endpoint_pdf` :
            `${supplierTenantId}.${process.env.REACT_APP_WMS_API_URL}/tenants/${supplierTenantId}/route_records/store_order_endpoint_pdf`
          );

        const response = await axios.post(urlPath, 
        // const response = await axios.post("http://localhost:8003/api/tenants/wahmey/route_records/store_order_endpoint_pdf", 
        salesOrderData, {
            responseType: 'arraybuffer', // Ensure the response type is set to arraybuffer
        });

        // Create a Blob from the PDF data
        const pdfBlob = new Blob([response.data], { type: 'application/pdf' });

        // Create a URL for the Blob
        const pdfUrl = URL.createObjectURL(pdfBlob);

        // Open a new tab with the PDF
        const newTab = window.open(pdfUrl, '_blank');

        // handleClose()
    }

    function handleCatchWeightClick(orderId, productId) {
        const orderIndex = currentOrders.findIndex(order => order._id === orderId)
        let order = currentOrders.find(order => order._id === orderId)
        let newOrders = [...currentOrders]

        const currProductIndex = order.products.findIndex(product => product._id == productId)
        let currProduct = {...order.products[currProductIndex]}

        let catchWeights = []
        if(typeof currProduct.catchWeights == "undefined"){
            currProduct.catchWeights = catchWeights
        }

        newOrders[orderIndex].products[currProductIndex] = currProduct

        setCurrentOrders(newOrders)
        setCatchWeightProduct({...currProduct})
        setCatchWeightOrder({...order})

        setOpenCW(true);
    }

    function handleAddCatchWeight() {
        
        if(catchWeightProduct.catchWeights && catchWeightProduct.catchWeights.length >= catchWeightProduct.amount){
            // console.log("Don't do Shit!")
        } else if(typeof catchWeight === "number" && catchWeight > 0){
            const currOrderIndex = currentOrders.findIndex(order => order._id === catchWeightOrder._id)
            let currOrder = {...currentOrders[currOrderIndex]}
            let newOrders = [...currentOrders]

            const currProductIndex = currOrder.products.findIndex(product => product._id == catchWeightProduct._id)
            let currProduct = {...currOrder.products[currProductIndex]}
            
            if(currProduct.catchWeights){
                currProduct.catchWeights.push(catchWeight)
            } else{
                currProduct.catchWeights = [catchWeight]
            }

            let currProductPrice = getProductPrice(currProduct)
            if(currProductPrice == '' || currProductPrice == 0){
                currProductPrice = 0
            }
            const oldTotalCost = currOrder.totalCost
            let newTotalCost = oldTotalCost + (currProductPrice * catchWeight)

            newOrders[currOrderIndex].products[currProductIndex] = currProduct
            newOrders[currOrderIndex].totalCost = parseFloat(newTotalCost.toFixed(2))

            setCurrentOrders(newOrders)
            scheduleOrderPaymentRefetch(catchWeightOrder._id)
            setCatchWeightOrder(currOrder)
            setCatchWeightProduct(currProduct)
            setCatchWeight("")
        }
    }

    function handleRemoveCatchWeight(cw) {
        
        if(catchWeightProduct.catchWeights && catchWeightProduct.catchWeights.length > 0){
            
            const currOrderIndex = currentOrders.findIndex(order => order._id === catchWeightOrder._id)
            let currOrder = {...currentOrders[currOrderIndex]}
            let newOrders = [...currentOrders]

            const currProductIndex = currOrder.products.findIndex(product => product._id == catchWeightProduct._id)
            let currProduct = {...currOrder.products[currProductIndex]}
            
            
            const currrCatchWeightIndex = currProduct.catchWeights.findIndex(catchWeight => catchWeight == cw)
            let catchWeightRemoved = 0
            if (currrCatchWeightIndex > -1) {
                catchWeightRemoved = currProduct.catchWeights[currrCatchWeightIndex]
                currProduct.catchWeights.splice(currrCatchWeightIndex, 1)
            }

            let currProductPrice = getProductPrice(currProduct)
            if(currProductPrice == '' || currProductPrice == 0){
                currProductPrice = 0
            }
            const oldTotalCost = currOrder.totalCost
            let newTotalCost = oldTotalCost - (currProductPrice * catchWeightRemoved)

            newOrders[currOrderIndex].products[currProductIndex] = currProduct
            newOrders[currOrderIndex].totalCost = parseFloat(newTotalCost.toFixed(2))

            setCurrentOrders(newOrders)
            scheduleOrderPaymentRefetch(catchWeightOrder._id)
            setCatchWeightOrder(currOrder)
            setCatchWeightProduct(currProduct)
        }
    }

    // Helper function to check if a product has multiple units of measurement
    const hasMultipleUnits = (product) => {
        return product.unitsOfMeasurement && product.unitsOfMeasurement.length > 1;
    }

    // Helper function to check if any product in an order has multiple units
    const orderHasMultipleUnits = (order) => {
        return order.products.some(product => hasMultipleUnits(product));
    }

    let componentType = <ProductsList filterCategory={{}} supplier={supplier} categories={fullCategoryTree} company={company} locations={locations} 
                                        currentOrders={currentOrders} setCurrentOrders={setCurrentOrders} defaultInvoiceDate={defaultInvoiceDate} defaultShipDate={defaultShipDate}
                                        user={user}
                                         />
    // if(categoriesTree.selectedCategories.length == 0){
    //     componentType = <MainCategory categories={objectsArray} categoriesTree={categoriesTree} setCategoriesTree={setCategoriesTree} setCategories={setObjectsArray} 
    //             company={company} handleClickOpen={handleClickOpen} handleClose={handleClose} />
    // }else if(categoriesTree.selectedCategories[categoriesTree.selectedCategories.length - 1].children.length > 0){
    //     componentType = <CategoriesCard  categories={objectsArray} categoriesTree={categoriesTree} setCategoriesTree={setCategoriesTree} setCategories={setObjectsArray}/>
    // }else{
    //     componentType = <ProductsList filterCategory={{}} supplier={supplier} categories={fullCategoryTree} company={company} locations={locations}/>
    // }

    console.log("Current orders: ", currentOrders)

    return (

        <>
            { isDataFetched ? (
            <>
                <div className="row mb-4 justify-content-between">
                    <div>
                        <span className="text-dark font-weight-bolder text-hover-primary mb-1 font-size-lg mr-2 cursor-pointer"
                            onClick={() => {
                                setIsSupplerSelected(false);
                            } }
                        >Suppliers /</span>
                        <span className="text-dark font-weight-bolder text-hover-primary mb-1 font-size-lg mr-2 cursor-pointer"
                            onClick={() => {
                                setCategoriesTree({
                                    branches: 0,
                                    selectedCategories: [],
                                    categoryType: defaultCategory,
                                    children: categoriesTree.children
                                });
                                setObjectsArray(categoriesTree.children);
                            } }
                        >{supplier.entityName} Home</span>

                        {categoriesTree.selectedCategories.map((category, index) => {

                            if (categoriesTree.branches === index + 1) {
                                return (
                                    <span key={category.name + index} className="text-dark font-weight-bolder mb-1 font-size-lg mr-2">/ {category.name}</span>
                                );
                            } else {
                                return (
                                    <span key={category.name + index} className=" text-dark text-hover-primary font-weight-bolder mb-1 font-size-lg mr-2 cursor-pointer"
                                        onClick={() => {
                                            setCategoriesTree({
                                                branches: index + 1,
                                                selectedCategories: categoriesTree.selectedCategories.slice(0, index + 1),
                                                categoryType: category.childType,
                                                children: categoriesTree.children
                                            });

                                            setObjectsArray(category.children);

                                            console.log(categoriesTree);
                                        } }
                                    > {category.name}</span>
                                );
                            }
                        })}
                    </div>
                </div>
                <button type="button" className="btn btn-primary mb-6" onClick={() => handleBack()} >Back</button>
                    <Card>
                        <CardHeader title={supplier.entityName}>

                        </CardHeader>
                        <CardBody>
                            {/* <div className="row">
                                <p>{supplier.description}</p>
                            </div> */}
                            <div className="row">
                                <p>To show items select customer first.</p>
                            </div>
                            <div className="row mb-4">
                                <div className="col-12">
                                    <FormControl variant="filled" style={{ width: "100%" }}>
                                        {
                                            user.isSeller ? 
                                                <InputLabel>Customer</InputLabel>
                                                :
                                                <InputLabel>Company</InputLabel>
                                        }
                                        <Select
                                            MenuProps={{ autoFocus: false }}
                                            value={company._id}
                                            style={{ minWidth: "200px" }}
                                            input={<FilledInput name="company" id="company"
                                                onChange={(element) => {
                                                    handleCompanyChange(element);
                                                    // setCompany(companies.find(company => company._id == element.target.value))
                                                    // setLocations(companies.find(company => company._id == element.target.value).locations)
                                                } }
                                                onClose={() => setSearchText("")}
                                                type="text"
                                                className="form-control form-control-solid h-auto" />}>

                                            <ListSubheader>
                                                <TextField
                                                    size="small"
                                                    // Autofocus on textfield
                                                    autoFocus
                                                    placeholder="Type to search..."
                                                    fullWidth
                                                    InputProps={{
                                                        startAdornment: (
                                                        <InputAdornment position="start">
                                                            <SearchIcon />
                                                        </InputAdornment>
                                                        )
                                                    }}
                                                    onChange={(e) => setSearchText(e.target.value)}
                                                    onKeyDown={(e) => {
                                                        if (e.key !== "Escape") {
                                                            // Prevents autoselecting item while typing (default Select behaviour)
                                                            e.stopPropagation();
                                                        }
                                                    }}
                                                />
                                            </ListSubheader> 
                                            {displayedOptions.map((companyItem,index) =>(
                                                <MenuItem key={companyItem._id} selected={index === 0 } value={companyItem._id}>
                                                    {companyItem.businessName + (companyItem.balance ? ` (Balance: $${companyItem.balance})` : "")}
                                                </MenuItem>
                                            ))

                                            }

                                        </Select>
                                    </FormControl>
                                </div>
                            </div>
                            <div className="row">
                                <div className="mb-4 form-group fv-plugins-icon-container">
                                    <label htmlFor={"invoiceDate"}>Invoice Date</label>
                                    <Input
                                        type="date"
                                        className={`form-control form-control-solid h-auto py-5 px-6`}
                                        name="personalBirthDate"
                                        value={defaultInvoiceDate}
                                        onChange={(e) => handleDefaultInvoiceDateChange(e)}
                                    />
                                </div>
                                { user.tenant != process.env.REACT_APP_WAHMEY_TENANT ? 
                                    <div className="mb-4 ml-3 form-group fv-plugins-icon-container">
                                        <label htmlFor={"invoiceDate"}>Ship Date</label>
                                        <Input
                                            type="date"
                                            className={`form-control form-control-solid h-auto py-5 px-6`}
                                            name="personalBirthDate"
                                            value={defaultShipDate}
                                            onChange={(e) => handleDefaultShipDateChange(e)}
                                        />
                                    </div>
                                    :
                                    null
                                }
                                
                            </div>
                        </CardBody>
                        {
                            isCompanySelected ?
                            componentType
                            :
                            null
                        }
                    </Card>
                    {
                        currentOrders.length > 0 ?
                            currentOrders.map((order, index) => 
                                <Card key={`currentOrders-${order.orderNumber}`}>
                                    <CardHeader title={`Order #: ${order?.orderNumber} | ${order?.companyName}`}>

                                    </CardHeader>
                                    <CardBody>
                                        <div className="text-dark-50 line-height-lg">
                                            <div className="table-responsive">
                                                <table className="table">
                                                    <thead>
                                                        <tr className='border-bottom'>
                                                            <th className="pl-0 font-weight-bold text-muted text-uppercase">Ordered
                                                                Items
                                                            </th>
                                                            <th className="text-center font-weight-bold text-muted text-uppercase">Unit
                                                                Price
                                                            </th>
                                                                            {
                                                                                order.products.some(p => !p.isExternal) && !isExternalBuyer(user) ?
                                                                                    <th className="text-center font-weight-bold text-muted text-uppercase">{getInventoryColumnLabel()}</th>
                                                                                :
                                                                                    <th className="text-center font-weight-bold text-muted text-uppercase"></th>
                                                                            }
                                                            <th className="text-center font-weight-bold text-muted text-uppercase">Qty To Order</th>
                                                            <th className="text-center font-weight-bold text-muted text-uppercase">UoM</th>
                                                            <th className="text-right font-weight-bold text-muted text-uppercase">Item
                                                                Price
                                                            </th>
                                                            {
                                                                order.shipVia == "HOME" ? 
                                                                    <th className="text-center font-weight-bold text-muted text-uppercase">
                                                                        Catch Weight
                                                                    </th>
                                                                :
                                                                    null
                                                            }
                                                            <th className="text-right font-weight-bold text-muted text-uppercase">Total
                                                                Price
                                                            </th>
                                                            <th className="text-right pr-0 font-weight-bold text-muted text-uppercase">Remove</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                    {order.products.map(product => (
                                                        <tr className="font-weight-boldest border-bottom-0">
                                                            <td className="border-top-0 pl-0 py-2 align-middle">
                                                                {
                                                                    product.imagePath && product.imagePath != '' ?
                                                                        <div className="symbol symbol-40 flex-shrink-0 mr-4 bg-light">
                                                                            <div className="symbol-label"
                                                                                style={{backgroundImage: "url(" + product.imagePath + ")"}}>
                                                                            </div>
                                                                        </div>
                                                                    :
                                                                        null
                                                                }
                                                                
                                                                <div>
                                                                    <span className={'text-dark-75 font-weight-bolder text-hover-primary d-block font-size-lg'}>
                                                                        {product.name}
                                                                    </span>
                                                                    {product.itemNumber && (
                                                                        <span className={'text-muted font-weight-bold d-block'}>
                                                                            {product.itemNumber}
                                                                        </span>
                                                                    )}
                                                                    <span className={'text-muted font-weight-bold'}>
                                                                        {product.sku}
                                                                    </span>
                                                                </div>
                                                            </td>
                                                            <td className="border-top-0 text-right py-2 align-middle" style={{minWidth:"125px"}}>
                                                                {user.tenant === process.env.REACT_APP_PEPEGANGA_TENANT || isBuyerPriceEditLocked(supplier) ? (
                                                                    <span className="text-dark font-weight-bolder text-hover-primary font-size-lg">
                                                                        ${getProductPrice(product)}
                                                                    </span>
                                                                ) : (
                                                                    <NumberInput
                                                                        value={getProductPrice(product)}
                                                                        onChange={(e) => handlePriceChange(order._id, product._id, e.target.value)}
                                                                        className={`form-control form-control-solid h-auto py-2 px-6`}
                                                                        min="0"
                                                                        disabled={!canEditOrder(order)}
                                                                    />
                                                                )}
                                                            </td>
                                                                            {
                                                                                (() => {
                                                                                    const stockQty = getInventoryQty(product, user);
                                                                                    return !product.isExternal && stockQty !== null
                                                                                        ? <td className="border-top-0 text-center py-2 align-middle">{stockQty}</td>
                                                                                        : <td className="border-top-0 text-center py-2 align-middle"></td>;
                                                                                })()
                                                                            }
                                                            <td className="border-top-0 text-center py-2 align-middle" style={{minWidth:"125px"}}>
                                                                <NumberInput
                                                                    value={product.amount}
                                                                    onChange={(e) => handleProductAmountChange(order._id, product._id, e.target.value)}
                                                                    className={`form-control form-control-solid h-auto py-2 px-6`}
                                                                    min="0"
                                                                    disabled={!canEditOrder(order)}
                                                                />
                                                            </td>
                                                            <td className="border-top-0 text-center py-2 align-middle">
                                                                {hasMultipleUnits(product) ? (
                                                                    <div className="form-group fv-plugins-icon-container align-middle">
                                                                        <Select
                                                                            value={product.selectedUnit.uomId}
                                                                            onChange={(e) => handleProductUnitChange(order._id, product._id, e.target.value)}
                                                                            disabled={!canEditOrder(order)}
                                                                            input={
                                                                                <FilledInput
                                                                                name={`product-${product.selectedUnit.uomId}`}
                                                                                id={`product-${product.selectedUnit.uomId}`}
                                                                                className="form-control form-control-solid h-2 py-2 px-6 align-middle"
                                                                                disabled={!canEditOrder(order)}
                                                                                />
                                                                            }
                                                                            >
                                                                            {product.unitsOfMeasurement.map(uom => (
                                                                                <MenuItem key={uom.uomId} value={uom.uomId}>
                                                                                    {`${uom.name} (${uom.conversionFactor})`}
                                                                                </MenuItem>
                                                                            ))}
                                                                        </Select>
                                                                    </div>
                                                                ) : (
                                                                    <span className="text-dark font-weight-bolder text-hover-primary font-size-lg">
                                                                        {product.selectedUnit ? `${product.selectedUnit.name} (${product.selectedUnit.conversionFactor})` : `${product.defaultUnitOfMeasurement.name} (${product.defaultUnitOfMeasurement.conversionFactor})`}
                                                                    </span>
                                                                )}
                                                            </td>
                                                            <td className="border-top-0 text-center py-2 align-middle">
                                                                ${getProductPrice(product)}
                                                            </td>
                                                            {
                                                                order.shipVia == "HOME" ? 
                                                                    product.isCatchWeight ?
                                                                        <td className="border-top-0 text-center d-flex justify-content-center">
                                                                            <IconButton  
                                                                                onClick={() => handleCatchWeightClick(order._id, product._id)}
                                                                                disabled={!canEditOrder(order)}
                                                                            >
                                                                            <span  className={`center svg-icon svg-icon-md ${product.amount == product.catchWeights?.length ? "svg-icon-success" : "svg-icon-danger"}`}>
                                                                                <SVG src={toAbsoluteUrl("/media/svg/icons/Shopping/Box1.svg")} />
                                                                            </span>
                                                                            </IconButton>
                                                                        </td>
                                                                        :
                                                                        <td className="border-top-0 text-center py-2 align-items-center">
                                                                            N/A
                                                                        </td>
                                                                    :
                                                                    null
                                                            }
                                                            <td className="border-top-0 text-right py-2 align-middle">
                                                                {(() => {
                                                                    const productPrice = getProductPrice(product)
                                                                    if(product.isCatchWeight) {
                                                                        return "$" + (productPrice * (product?.catchWeights?.length > 0 ? product?.catchWeights?.reduce((total, currWeight) => total + parseFloat(currWeight)) : 0)).toFixed(2)
                                                                    } else {
                                                                        return "$" + (productPrice * product.amount * (product.selectedUnit ? product.selectedUnit.conversionFactor : 1)).toFixed(2)
                                                                    }
                                                                })()}
                                                            </td>
                                                            
                                                            <td className="border-top-0 text-right py-2 align-middle">
                                                                <InputAdornment position="end">
                                                                    <IconButton  
                                                                        onClick={() => handleRemove(order._id, product._id)}
                                                                        disabled={!canEditOrder(order)}
                                                                    >
                                                                    <span  className="center svg-icon svg-icon-md svg-icon-primary">
                                                                        <SVG src={toAbsoluteUrl("/media/svg/icons/General/Trash.svg")} />
                                                                    </span>
                                                                    </IconButton>
                                                                </InputAdornment>
                                                            </td>
                                                            {/*<td className="text-primary border-top-0 pr-0 py-4 text-right align-middle">$449.00</td>*/}
                                                        </tr>
                                                    ))}
                                                        <tr className="font-weight-boldest border-bottom-0">
                                                            <td className="pl-0 py-4 d-flex align-items-center">Total</td>
                                                            <td ></td>
                                                            <td ></td>
                                                            <td className="text-center py-4 align-middle">{order.totalProductQty}</td>
                                                            <td ></td>
                                                            {
                                                                order.shipVia == "HOME" ? 
                                                                    <td ></td>
                                                                :
                                                                    null
                                                            }
                                                            <td ></td>
                                                            <td className="text-right py-4 align-middle">
                                                                {onlinePaymentEnabled && getPaymentSummary(order) ? (
                                                                    <PaymentTaxBreakdown summary={getPaymentSummary(order)} />
                                                                ) : (
                                                                    `$${order.totalCost}`
                                                                )}
                                                            </td>

                                                        </tr>
                                                    {/*<tr className='border-top'>*/}
                                                    {/*    <td colSpan="2"></td>*/}
                                                    {/*    <td className="font-weight-bolder text-right">Subtotal</td>*/}
                                                    {/*    <td className="font-weight-bolder text-right pr-0">$1538.00</td>*/}
                                                    {/*</tr>*/}
                                                    {/*<tr>*/}
                                                    {/*    <td colSpan="2" className="border-0 pt-0"></td>*/}
                                                    {/*    <td className="border-0 pt-0 font-weight-bolder text-right">Delivery*/}
                                                    {/*        Fees*/}
                                                    {/*    </td>*/}
                                                    {/*    <td className="border-0 pt-0 font-weight-bolder text-right pr-0">$15.00</td>*/}
                                                    {/*</tr>*/}
                                                    {/*<tr>*/}
                                                    {/*    <td colSpan="2" className="border-0 pt-0"></td>*/}
                                                    {/*    <td className="border-0 pt-0 font-weight-bolder font-size-h5 text-right">Grand*/}
                                                    {/*        Total*/}
                                                    {/*    </td>*/}
                                                    {/*    <td className="border-0 pt-0 font-weight-bolder font-size-h5 text-success text-right pr-0">$1553.00</td>*/}
                                                    {/*</tr>*/}
                                                    </tbody>
                                                </table>

                                            </div>
                                        </div>
                                        
                                    </CardBody>
                                    <CardFooter>
                                        <div className="row justify-content-between mb-3">
                                            <div className="d-flex">
                                                {
                                                    isSubmitExpanded ?
                                                        <button className="btn btn-primary" onClick={() => setIsSubmitExpanded(oldIsSubmitExpanded => !oldIsSubmitExpanded)}>Close</button>
                                                        :
                                                        !user.roles.includes("buyer_creator") ? (
                                                            <button className="btn btn-primary" onClick={() => {
                                                                if (!isSubmitExpanded && onlinePaymentEnabled && supplier?.payment?.enabled) {
                                                                    fireAlert(
                                                                        "Complete your order in the cart",
                                                                        "Online payment is enabled for your account. You will be taken to your cart to use Pay & Submit or Pay on Delivery."
                                                                    );
                                                                    setTimeout(() => history.push("/orders/confirmation"), 400);
                                                                    return;
                                                                }
                                                                setIsSubmitExpanded(oldIsSubmitExpanded => !oldIsSubmitExpanded)
                                                                // Auto-select ship via if only one option is available
                                                                autoSelectShipVia(index)
                                                            }}>Submit</button>
                                                        ) : null
                                                }
                                            </div>
                                        </div>
                                        <Collapse in={isSubmitExpanded} timeout="auto" unmountOnExit>
                                            <div>
                                                <Grid container spacing={3}>
                                                    <Grid item xs={6}>
                                                        <div className="form-group fv-plugins-icon-container">
                                                            {process.env.REACT_APP_MCS_TENANT === user.tenant ? (
                                                                <>
                                                                    <label htmlFor={"orderComent"}>Special Instructions</label>
                                                                    <textarea
                                                                        value={order.comment}
                                                                        onChange={(e) => handleOrderCommentChange(index, e.target.value)}
                                                                        className={`form-control form-control-solid h-auto py-2 px-6`}
                                                                        placeholder={"Special Instructions"}
                                                                        rows="3"
                                                                    />
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <label htmlFor={"orderComent"}>Comment</label>
                                                                    <textarea
                                                                        value={order.comment}
                                                                        onChange={(e) => handleOrderCommentChange(index, e.target.value)}
                                                                        className={`form-control form-control-solid h-auto py-2 px-6`}
                                                                        placeholder={"Comment"}
                                                                        rows="3"
                                                                    />
                                                                </>
                                                            )}
                                                        </div>
                                            <div className="form-group fv-plugins-icon-container">
                                                <label htmlFor={"customerPo"}>Customer PO</label>
                                                <input
                                                    value={order.customerPo}
                                                    onChange={(e) => handleOrderCustomerPoChange(index, e.target.value)}
                                                    className={`form-control form-control-solid h-auto py-2 px-6`}
                                                                placeholder={"Customer PO"}
                                                                type="text"
                                                            />
                                                        </div>

                                                        {process.env.REACT_APP_MCS_TENANT === user.tenant ? (
                                                            <div>
                                                                <div className="form-group fv-plugins-icon-container">
                                                                    <label htmlFor={"deliveryPurpose"}>Delivery
                                                                        Purpose</label>
                                                                    <input
                                                                        value={order.deliveryPurpose}
                                                                        onChange={(e) => handleDeliveryPurposeChange(index, e.target.value)}
                                                                        className={`form-control form-control-solid h-auto py-2 px-6`}
                                                                        placeholder={"Delivery Purpose"}
                                                                        type="text"
                                                                    />
                                                                </div>
                                                                <div className="form-group fv-plugins-icon-container">
                                                                    <label htmlFor={"contactPerson"}>Contact Person</label>
                                                                    <input
                                                                        value={order.contactPerson}
                                                                        onChange={(e) => handleContactPerson(index, e.target.value)}
                                                                        className={`form-control form-control-solid h-auto py-2 px-6`}
                                                                        placeholder={"Contact Person"}
                                                                        type="text"
                                                                    />
                                                                </div>
                                                                <div className="form-group fv-plugins-icon-container">
                                                                    <label htmlFor={"phoneNumber"}>Phone Number</label>
                                                                    <input
                                                                        value={order.phoneNumber}
                                                                        onChange={(e) => handlePhoneNumber(index, e.target.value)}
                                                                        className={`form-control form-control-solid h-auto py-2 px-6`}
                                                                        placeholder={"Phone Number"}
                                                                        type="text"
                                                                    />
                                                                </div>
                                                            </div>

                                                        ) : (
                                                            
                                                        <FormControl variant="filled" style={{ width: "100%" }}>
                                                            <InputLabel>Ship Via</InputLabel>
                                                            <Select
                                                                MenuProps={{ autoFocus: false }}
                                                                value={order.shipVia}
                                                                style={{ minWidth: "200px" }}
                                                                input={<FilledInput name="shipVia" id="shipVia"
                                                                    onChange={(e) => {
                                                                        handleOrderShipViaChange(index, e.target.value, order._id);
                                                                    } }
                                                                    type="text"
                                                                    className="form-control form-control-solid h-auto" />}>

                                                                <MenuItem selected key={`${order._id}-${company?.shipVia}`} value={company?.shipVia}>{company?.shipVia == "Our Truck" ? "Delivery" : company?.shipVia == "HOME" ? "Pick Up" : company?.shipVia}</MenuItem>
                                                                {
                                                                    supplier.shipViaOptions.map((option,optionIndex) =>(
                                                                        company?.shipVia == option ?
                                                                        null
                                                                        :
                                                                        <MenuItem key={option} value={option}>{option == "Our Truck" ? "Delivery" : option == "HOME" ? "Pick Up" : option}</MenuItem>
                                                                    ))
                                                                }
                                                            </Select>
                                                        </FormControl>
                                                        )}
                                                    </Grid>
                                                    <Grid item xs={6}>
                                                        <div className="form-group fv-plugins-icon-container">
                                                            <label htmlFor={"invoiceDate"}>Invoice Date</label>
                                                            <Input
                                                                type="date"
                                                                className={`form-control form-control-solid h-auto py-5 px-6`}
                                                                name="personalBirthDate"
                                                                value={order.invoiceDate}
                                                                onChange={(e) => handleOrderInvoiceDateChange(index, e.target.value)}
                                                            />
                                                        </div>
                                                        <div className="form-group fv-plugins-icon-container">
                                                            <label htmlFor={"shipDate"}>Ship Date</label>
                                                            <Input
                                                                type="date"
                                                                className={`form-control form-control-solid h-auto py-5 px-6`}
                                                                name="personalBirthDate"
                                                                value={order.shipDate}
                                                                onChange={(e) => handleOrderShipDateChange(index, e.target.value)}
                                                            />
                                                        </div>

                                                        {/*New Fields*/}
                                                        {process.env.REACT_APP_MCS_TENANT === user.tenant ? (
                                                            <>
                                                                <div className="form-group fv-plugins-icon-container">
                                                                    <label htmlFor={"expectedDeliveryDate"}>Expected
                                                                        Delivery Date</label>
                                                                    <Input
                                                                        type="date"
                                                                        className={`form-control form-control-solid h-auto py-5 px-6`}
                                                                        name="expectedDeliveryDate"
                                                                        value={order.expectedDeliveryDate}
                                                                        onChange={(e) => handleOrderExpectedDeliveryDateChange(index, e.target.value)}
                                                                    />
                                                                </div>

                                                                <FormControl variant="filled" style={{width: "100%"}}>
                                                                    <InputLabel>Ship To</InputLabel>
                                                                    <Select
                                                                        MenuProps={{autoFocus: false}}
                                                                        value={order.allecInvWareHouse}
                                                                        style={{minWidth: "200px"}}
                                                                        onChange={(e) => {
                                                                            handleOrderShipToChange(index, e.target.value);
                                                                        }}
                                                                        input={
                                                                            <FilledInput
                                                                                name="allecInvWareHouse"
                                                                                id="allecInvWareHouse"
                                                                                type="text"
                                                                                className="form-control form-control-solid h-auto"
                                                                            />
                                                                        }
                                                                    >
                                                                        {
                                                                            supplier.warehouses?.map((warehouse) => (
                                                                                <MenuItem
                                                                                    key={warehouse.id}
                                                                                    value={warehouse.id}
                                                                                >
                                                                                    {warehouse.name}
                                                                                </MenuItem>
                                                                            ))
                                                                        }
                                                                    </Select>
                                                                </FormControl>

                                                                <div>
                                                                    <label htmlFor={"proofOfDeliveryToggle"}>Proof of
                                                                        Delivery</label>
                                                                    <Switch
                                                                        checked={order.proofOfDelivery}
                                                                        onChange={(e) => handleProofOfDeliveryChange(index, e.target.checked)}
                                                                        name="proofOfDeliveryToggle"
                                                                        color="primary"
                                                                    />
                                                                </div>
                                                            </>
                                                        ) : (
                                                            <></>
                                                        )}

                                                    </Grid>
                                                </Grid>
                                            </div>
                                            <div className="row col-12 justify-content-center mt-5">
                                                {!user.roles.includes("buyer_creator") ? (
                                                    <button type="button" className="btn btn-primary"
                                                            onClick={() => handleSubmitSingleOrder(index)}>Submit
                                                    </button>
                                                ) : null}
                                            </div>
                                        </Collapse>
                                    </CardFooter>
                                </Card>
                            )
                            :
                            null
                    }
                    {
                        currentOrders.length > 0 ?
                            <div className="row py-8 px-8 py-md-27 px-md-0">
                                <div>
                                    <button type="button" className="btn btn-success font-weight-bolder text-uppercase px-9 py-4 ml-5"
                                            data-wizard-type="action-submit"
                                            onClick={() =>{
                                                handleSaveOrders();
                                            }}>Save All
                                    </button>
                                </div>
                            </div>
                        :
                            null
                    }
                    <div>
                        <Dialog
                            open={open}
                            onClose={handleClose}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                        >
                            {
                                user.tenant == process.env.REACT_APP_BIOWARE_TENANT ?
                                    <DialogTitle id="alert-dialog-title">{"Choose Customer"}</DialogTitle>
                                :
                                    <DialogTitle id="alert-dialog-title">{"Choose Company"}</DialogTitle>
                            }
                            <DialogContent>
                                {
                                    user.tenant == process.env.REACT_APP_BIOWARE_TENANT ?
                                        <DialogContentText id="alert-dialog-description">
                                            Please choose a customer to order to before moving forward.
                                            It can later be changed to purchase to various locations on the same order.
                                        </DialogContentText> 
                                    :
                                        <DialogContentText id="alert-dialog-description">
                                            Please choose a company to order to before moving forward.
                                            It can later be changed to purchase to various locations on the same order.
                                        </DialogContentText>
                                }
                                    
                                
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={handleClose} color="primary" autoFocus>
                                    OK
                                </Button>
                            </DialogActions>
                        </Dialog>
                    </div>
                    <div>
                        <Dialog
                            open={notApprovedOpen}
                            onClose={handleNotApprovedClose}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                        >
                            <DialogTitle id="alert-dialog-title">{"Not Approved"}</DialogTitle>
                            <DialogContent>
                                {
                                    user.isSeller ?
                                        <DialogContentText id="alert-dialog-description">
                                            Customer locations have not been approved by this supplier.
                                        </DialogContentText>
                                    :
                                        <DialogContentText id="alert-dialog-description">
                                            Company locations have not been approved by this supplier.
                                        </DialogContentText>
                                }
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={handleNotApprovedClose} color="primary" autoFocus>
                                    OK
                                </Button>
                            </DialogActions>
                        </Dialog>
                    </div>
                    <div>
                        <Dialog
                            open={alertOpen}
                            onClose={handleAlertClose}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                        >
                            <DialogTitle id="alert-dialog-title">{alertTitle}</DialogTitle>
                            <DialogContent>
                                <DialogContentText id="alert-dialog-description">
                                    {alertText}
                                </DialogContentText>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={handleAlertClose} color="primary" autoFocus>
                                    OK
                                </Button>
                                { invoice?.shipVia == "HOME" ?
                                    <Button onClick={() => handlePrintInvoice()} color="primary" autoFocus>
                                        Print Invoice
                                    </Button>
                                    :
                                    null
                                }
                                {
                                    user.isBuyerAdmin && currOrderIndex != null && currOrderIndex >= 0 ? 
                                        <Button onClick={() => handleSubmitSingleOrder(currOrderIndex, true)} color="primary" autoFocus>
                                            Force Submit
                                        </Button>
                                    :
                                    null
                                }
                            </DialogActions>
                        </Dialog>
                    </div>
                    <Dialog
                        open={openCW}
                        onClose={handleCloseCW}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogTitle id="alert-dialog-title">{"Catch Weight Input"}</DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">
                                <div className="d-flex flex-column text-md-left">
                                    <span><span className="mb-1 font-weight-bolder">Product: </span> {catchWeightProduct?.name}</span>
                                    <span><span className="mb-1 font-weight-bolder">Sku: </span> {catchWeightProduct?.sku}</span>
                                    <span><span className="mb-1 font-weight-bolder">Left to Add: </span> {(catchWeightProduct?.amount - (catchWeightProduct?.catchWeights?.length ? catchWeightProduct?.catchWeights?.length : 0))}</span>
                                </div>
                            </DialogContentText>   

                            Weight: { (catchWeightProduct?.catchWeights.length > 0 ? catchWeightProduct?.catchWeights?.reduce((total, currWeight) => total + parseFloat(currWeight)) : 0).toFixed(2)}
                            <div className="row justify-content-between py-8 px-20 py-md-10 px-md-0">
                                <div className="d-flex">
                                    <NumberInput
                                        value={catchWeight}
                                        onChange={(e) => setCatchWeight(Number(e.target.value))}
                                        onKeyDown={(e) => {
                                            if (e.key === "Enter") {
                                                handleAddCatchWeight()
                                            }
                                        }}
                                        className={`form-control form-control-solid h-auto py-2 px-6`}
                                        min="0"
                                        style={{minWidth:"125px"}}
                                    />
                                    <Button onClick={() => handleAddCatchWeight()} color="primary" autoFocus>
                                        Add
                                    </Button>
                                </div>
                            </div>
                            
                            <div className="table-responsive">
                                <table className="table">
                                    <thead>
                                        <tr className='border-bottom'>
                                            <th className="text-center font-weight-bold text-muted text-uppercase">Product</th>
                                            <th className="text-center font-weight-bold text-muted text-uppercase">Weight</th>
                                            <th className="text-center font-weight-bold text-muted text-uppercase">Remove </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {   catchWeightProduct && catchWeightProduct.catchWeights?
                                                catchWeightProduct.catchWeights.map(cw => (
                                                    <tr className="font-weight-boldest border-bottom-0">
                                                        <td className="border-top-0 text-center py-2 align-items-center">
                                                            {catchWeightProduct?.name + " (" + catchWeightProduct?.sku + ")"}
                                                        </td>
                                                        <td className="border-top-0 text-center py-2 align-items-center">
                                                            {cw}
                                                        </td>
                                                        <td className="border-top-0 text-center py-2 align-items-center">
                                                            <InputAdornment position="end">
                                                                <IconButton  onClick={() => handleRemoveCatchWeight(cw)}
                                                                >
                                                                <span  className="center svg-icon svg-icon-md svg-icon-primary">
                                                                    <SVG src={toAbsoluteUrl("/media/svg/icons/General/Trash.svg")} />
                                                                </span>
                                                                </IconButton>
                                                            </InputAdornment>
                                                        </td>
                                                    </tr>
                                                ))
                                            :
                                            null
                                        }
                                    </tbody>
                                </table>

                            </div>
                        </DialogContent>
                        <DialogActions>
                        <Button onClick={handleCloseCW} color="primary" autoFocus>
                            Close
                        </Button>
                        </DialogActions>
                    </Dialog>
                </>
            ) : null
            }
        </>
    )

}